import { createContext, useContext, useState } from "react";

const QuickAccessContext = createContext();

export const QuickAccessProvider = ({ children }) => {
  const [isQuickAccessOpen, setIsQuickAccessOpen] = useState(false);

  return (
    <QuickAccessContext.Provider
      value={{ isQuickAccessOpen, setIsQuickAccessOpen }}
    >
      {children}
    </QuickAccessContext.Provider>
  );
};

export const useQuickAccess = () => useContext(QuickAccessContext);
